import Linkedin from "assets/linkedinData.png";
import Site from "assets/siteData.png";
import Youtube from "assets/youtubeData.png";
// import { SignatureIcon } from "../SignatureIcon/SignatureIcon";
// import { StyledTr } from "./SignatureDataIcons.styles";

export const SignatureDataIcons = () => {
  return (
    <table style={{ marginLeft: "auto" }}>
      <tbody>
        <tr>
          <td>
            <a href={"https://www.linkedin.com/company/teltec-data/"} rel="noopener noreferrer">
              <img src={Linkedin} alt={"Teltec Data Linkedin"} />
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <a href={"https://www.youtube.com/@teltecdata/"} rel="noopener noreferrer">
              <img src={Youtube} alt={"Teltec Data Youtube"} />
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <a href={"https://teltecdata.com.br/"} rel="noopener noreferrer">
              <img src={Site} alt={"Teltec Data Site"} />
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
